import { render, staticRenderFns } from "./RpmCarePlan.vue?vue&type=template&id=0c09c808&scoped=true&"
import script from "./RpmCarePlan.vue?vue&type=script&lang=js&"
export * from "./RpmCarePlan.vue?vue&type=script&lang=js&"
import style0 from "./RpmCarePlan.vue?vue&type=style&index=0&id=0c09c808&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c09c808",
  null
  
)

export default component.exports